import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'


export const getNominas = async () => {
  const response = await PrivateInterceptor('Payrolls/Maestros/getNominas', 'GET');
  return response;
}

export const chageEstadoPlanillas = async (data) => {
  const result = await PrivateInterceptor(`Payrolls/Maestros/chageEstadoPlanillas`, 'POST', data);
  return result;
}

export const GuardarNomina = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/GuardarNomina", "POST", {Datos});
  return respuesta;
};

export const EditarNomina = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/EditarNomina", "POST", {Datos});
  return respuesta;
};


//---------------------------------------ASPIRANTES--------------------------------------

export const getAspirantes = async () => {
  const response = await PrivateInterceptor('Payrolls/Maestros/getAspirantes', 'GET');
  return response;
}

export const getIdiomas = async () => {
  const response = await PrivateInterceptor('Payrolls/Maestros/getIdiomas', 'GET');
  return response;
}

export const getIdiomasPorId = async (IdIdiomas) => {
  const response = await PrivateInterceptor('Payrolls/Maestros/getIdiomasPorId', 'POST', {IdIdiomas});
  return response;
}

export const chageEstadoAspirantes = async (data) => {
  const result = await PrivateInterceptor(`Payrolls/Maestros/chageEstadoAspirantes`, 'POST', data);
  return result;
}

export const GuardarAspirante = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/GuardarAspirante", "POST", {Datos});
  return respuesta
};

export const EditarAspirante = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/EditarAspirante", "POST", {Datos});
  return respuesta;
};

export const getFoto = async (NombreCompleto) => {
  const respuesta = await PrivateInterceptor(`Payrolls/Maestros/getFoto/`, 'POST', {NombreCompleto})
  return respuesta;
}

export const descargarFoto = async (nombre) => {
  const respuesta = await PrivateInterceptor(`Payrolls/Maestros/descargarFoto`, 'POST', {nombre})
  return respuesta;
}


export const eliminarFotos = async (Codigo, nombre) => {
  const respuesta = await PrivateInterceptor(`Payrolls/Maestros/eliminarFoto/${Codigo}/${nombre}`, 'DELETE')
  return respuesta;
}


export const mostrarFotos = async (nombre) => {
  const respuesta = await PrivateInterceptor(`Payrolls/Maestros/descargarFoto`, 'POST', {nombre})
  var binary = '';
  var bytes = [].slice.call(new Uint8Array(respuesta.data));
  bytes.forEach((b) => binary += String.fromCharCode(b));
  const base64String = window.btoa(binary);
  return base64String;
}

//-------------------------------------------TURNOS-------------------------------------------------------

export const GuardarTurno = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/GuardarTurno", "POST", {Datos});
  return respuesta;
};

export const EditarTurno = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/EditarTurno", "POST", {Datos});
  return respuesta;
};

export const chageEstadoTurnos = async (data) => {
  const result = await PrivateInterceptor(`Payrolls/Maestros/chageEstadoTurnos`, 'POST', data);
  return result;
}

export const getMotivosPago = async () => {
  const response = await PrivateInterceptor('Payrolls/Maestros/getMotivosPago', 'GET');
  return response;
}

export const getMotivosDeducciones = async () => {
  const response = await PrivateInterceptor('Payrolls/Maestros/getMotivosDeducciones', 'GET');
  return response;
}


export const GuardarMotivoPago = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/GuardarMotivoPago", "POST", {Datos});
  return respuesta;
};

export const EditarMotivoPago = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/EditarMotivoPago", "POST", {Datos});
  return respuesta;
};


export const GuardarMotivoDeduccion = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/GuardarMotivoDeduccion", "POST", {Datos});
  return respuesta;
};

export const EditarMotivoDeduccion = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Maestros/EditarMotivoDeduccion", "POST", {Datos});
  return respuesta;
};

export const chageEstadoMP = async (data) => {
  const result = await PrivateInterceptor(`Payrolls/Maestros/chageEstadoMP`, 'POST', data);
  return result;
}

export const chageEstadoMD = async (data) => {
  const result = await PrivateInterceptor(`Payrolls/Maestros/chageEstadoMD`, 'POST', data);
  return result;
}